import {TableButtonOptions} from "../../../Modules/ListPage/Components/Table/Buttons/TableButtonGroup";
import {ProfileButton} from "../../../Modules/ListPage/Components/Table/Buttons/ProfileButton";
import {BlockTenantTableButton} from "../../../Modules/Auth/Tenant/Component/BlockTenantTableButton";
import React from "react";
import UserProfileCustomSelect from "../../Component/Select/UserProfileCustomSelector";


const PRFILES_SCHEMA_NAME = 'profiles';

export const ProfileCustomSchema = (name, schema) => {

    const endpoint = `${process.env.REACT_APP_AUTH_SERVICE}v1/users/`;

    console.log('Customizando profile list schema', name, schema)
    if (!(name === PRFILES_SCHEMA_NAME)) {
        return;
    }

    schema.getEndpoint = () => {
        return endpoint;
    }

    const getColumnsOld = schema.getColumns();

    schema.getColumns = () => {
        getColumnsOld[0] = TableButtonOptions({
            deleteEndpoint: endpoint,
            width: 250,
            children: ({row, table}) => {
                return [
                    <ProfileButton row={row}/>,
                    <BlockTenantTableButton row={row} updateTable={() => {
                        table.setGlobalFilter(new Date());
                    }}/>]
            }
        });
        return getColumnsOld
    }

    schema.customizeResponseData = (data) => {
        return {
            content: data.content,
            pageCount: data.number,
            totalElements: data.totalElements,
            totalPages: data.totalPages
        }
    }
}


export const ProfileCustomFormSchema = (name, schema) => {
    console.log('Customizando profile form schema', name, schema);

    if (!(name === PRFILES_SCHEMA_NAME)) {
        return;
    }

    schema.formSchema = {
        type: "array",
        items: {
            "type": "object",
            "properties": {
                id: {type: "string"}
            }
        }
    }

    schema.uiSchema = {
        "ui:options": {
            label: false
        },
        "ui:field": (props) => {
            return (<UserProfileCustomSelect disabled={props.disabled} onlyId={true} required={props.required}
                                             value={props.formData} setValue={props.onChange}/>
            );
        }
    }

    schema.getSaveUrl = (id) => {
        return `${process.env.REACT_APP_NODE_SERVICE}auth/users/${id}/profiles`;
    }

    schema.getByIdUrl = (id) => `${process.env.REACT_APP_NODE_SERVICE}auth/users/${id}/profiles`;

    schema.formatObjectToGet = (data) => {

        return data.profiles;
    }


}
